import React from "react";
import us from ".././assets/us-tiny.jpg"
import "./Home.css"

export default function UsImg() {
    return (
        <div className="us-img-cont">
            <img id="us-img" src={us} alt="Us"/>
        </div>
    )
}